"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var UnsupportedView = function UnsupportedView() {
  return /*#__PURE__*/_react["default"].createElement("div", null, "This browser is uncapable of recording video");
};

var _default = UnsupportedView;
exports["default"] = _default;